import React, { useContext } from "react";
import { Loading } from "../components/loading";
import { AuthContext } from "../context/auth.provider";
import { Redirect } from "../components/redirect";

export const InitializePage = () => {
  const { voter } = useContext(AuthContext);

  if (!voter) {
    return (
      <Loading source="InitializePage" waitingFor={{ Voter: !!voter }} />
    );
  }

  return <Redirect to={`/voting/${voter.election_id}`} />;
};
